import { DataCell } from './datacell';
export default DataCell;